export const messages = {
  title: 'Packing',
  saving: 'Saving…',
  loading: 'Loading…',
  empty: 'No packing scenarios',
  clear: 'Clear Checks',
  cleared: 'Checks cleared',
  clearFailed: 'Failed to clear, please retry',
  loadFailed: 'Failed to load'
} as const
